import { ArbeitenData } from '@/types/service-response'
import { WorkDescription } from '@/model/master-data/WorkDescription'
import store from '@/store'
import { UiLanguageItem } from '@/types'

export class Work {
  private constructor (
    readonly id: number,
    readonly code: string,
    readonly color: string,
    readonly isErasable: boolean,
    readonly descriptionList: WorkDescription[]
  ) {}

  static createListFromResponse (data: ArbeitenData[]): Array<Work> {
    return data.map((item: ArbeitenData) => {
      return new Work(
        item.ID,
        item.Code,
        item.Farbe,
        item.IsErasable,
        WorkDescription.createListFromResponse(item.Bezeichnungen)
      )
    })
  }

  get getDescriptionLabel (): string {
    const selectedLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    if(selectedLanguage) {
      const foundDescription: WorkDescription | undefined = this.descriptionList.find((item: WorkDescription) => item.language === selectedLanguage.syzId)
      return foundDescription ? foundDescription.description : ''
    } else {
      return ''
    }
  }
}
